import * as types from "../actions/ActionTypes";
import initialState from "./InitialState";

export default function blackoutPeriodReducer(state = initialState.blackoutPeriod, action) {
  switch (action.type) {
    case types.GET_BLACKOUT_PERIOD_ACTIVE_SUCCESS:
      return action.status;
    case types.TOGGLE_BLACKOUT_PERIOD_SUCCESS:
      return action.status ? !state : state;
    default:
      return state;
  }
}
